// leftsidebar宽高
export const LEFTSIDEBARITEM_WH = {
  width: 120,
  height: 32,
}
